import { useRef, useEffect, useCallback, RefObject } from 'react'

type UseInfinityScrollProps = {
  loading: boolean
  hasMore: boolean
  onLoadMore: () => void
  rootRef: RefObject<HTMLElement>
}

const useInfinityScroll = ({
  loading,
  hasMore,
  onLoadMore,
  rootRef,
}: UseInfinityScrollProps) => {
  const observer = useRef<IntersectionObserver | null>(null)
  const observeTarget = useCallback(
    (node: HTMLElement | null) => {
      if (loading || !hasMore || !rootRef.current) return
      if (observer.current) observer.current.disconnect()

      observer.current = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            onLoadMore()
          }
        },
        {
          root: rootRef.current,
          threshold: 0.1,
        },
      )

      if (node) observer.current.observe(node)
    },
    [loading, hasMore, onLoadMore, rootRef],
  )
  useEffect(() => {
    return () => {
      if (observer.current) observer.current.disconnect()
    }
  }, [])
  return { observeTarget }
}

export default useInfinityScroll
